import React from "react";
import { useAppState } from "../state/AppStateContext";
import { t } from "../i18n/strings";

export default function Stars({ value = 0, onChange }) {
  const { lang } = useAppState();
  return (
    <div style={{ display: "flex", justifyContent: "center", gap: 6, color: "#f6d98a" }}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          onClick={() => onChange(n)}
          aria-label={t(lang, "starRating", { count: n })}
          style={{ background: "none", border: "none", padding: 5, cursor: "pointer", color: "inherit", opacity: n <= value ? 1 : 0.25 }}
        >
          <svg width="42" height="42" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2l2.9 6.3 6.9.7-5.2 4.6 1.5 6.8L12 17.8 5.9 20.4l1.5-6.8L2.2 9l6.9-.7L12 2z" />
          </svg>
        </button>
      ))}
    </div>
  );
}
